// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBKQ-n7djmWsSe3eMy1s2Gm9jcqZeJBTHg",
  authDomain: "greenwells-2bc86.firebaseapp.com",
  databaseURL: "https://greenwells-2bc86-default-rtdb.firebaseio.com",
  projectId: "greenwells-2bc86",
  storageBucket: "greenwells-2bc86.firebasestorage.app",
  messagingSenderId: "667116383495",
  appId: "1:667116383495:web:d144d3bfe729ce7ddfa9a2",
  measurementId: "G-PG4B6SB0PL",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { database, auth, storage };
